import { s as r } from "./string-trim.js";
import { s as t } from "./string-trim-forced.js";
var i = r.end,
  s = t("trimEnd") ? function () {
    return i(this);
  } : "".trimEnd;
export { s };